import { GlobalData } from "../../../constants/types";
import { authenticatedFetch } from "../../api";
import { StoreApi } from "../types";

export const getGlobalData = () => async ({ setState }: StoreApi) => {
    try {
        const global = await authenticatedFetch<GlobalData>("/wp-json/headstart/v1/global");
        setState({ global });
    } catch (error) {
        console.error("Error fetching global data", { error });
    }
};

export const fetchRegionsData = () => async ({ setState }: StoreApi) => {
    try {
        const global = await authenticatedFetch<GlobalData>("/wp-json/headstart/v1/regions");
        setState({ global });
    } catch (error) {
        console.error("Error fetching regions data", { error });
    }
};